import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const WorkspaceContext = createContext();

export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};

export const WorkspaceProvider = ({ children }) => {
  const [currentWorkspace, setCurrentWorkspace] = useState(
    JSON.parse(localStorage.getItem("currentWorkspace")) || null
  );
  const [workspaces, setWorkspaces] = useState([]);

  const fetchWorkspaces = async () => {
    try {
      const response = await api.get('workspaces/');
      const data = await response.data;
      setWorkspaces(data);
      
      // If there's no current workspace selected but we have workspaces, select the first one
      if (!currentWorkspace && data.length > 0) {
        selectWorkspace(data[0]);
      }
    } catch (error) {
      console.error('Error fetching workspaces:', error);
    }
  };

  useEffect(() => {
    fetchWorkspaces();
  }, []);

  const selectWorkspace = (workspace) => {
    setCurrentWorkspace(workspace);
    localStorage.setItem("currentWorkspace", JSON.stringify(workspace));
  };

  return (
    <WorkspaceContext.Provider
      value={{
        currentWorkspace,
        workspaces,
        selectWorkspace,
        fetchWorkspaces
      }}
    >
      {children}
    </WorkspaceContext.Provider>
  );
};